<template>
    <modal-component :modal_status="modal">
        <template v-slot:modal_header>
            <div class="modal-title custom-font-lg custom-font-bold">{{ is_edit ? 'Ubah' : 'Tambah' }} Produk</div>
            <button type="button" class="btn-close" @click="close_modal(false)"/>
        </template>
        <template v-slot:modal_body>
            <div class="row">
                <div class="col-12 mb-3" :class="validation.firstError('form.image') ? 'custom-form-error' : ''">
                    <label>Gambar</label>
                    <file-input
                        :reference="'image'"
                        :multiple="true"
                        :maximum="1"
                        :max_size="1024000"
                        :accept="'image/png, image/jpg, image/jpeg'"
                        :extensions="['png', 'jpg', 'jpeg']"
                        :aspect_ratio="{width: 1, height: 1}"
                        :min_compress="{width: 1000, height: 1000}"
                        :resize="{width: 1000, height: 1000}"
                        @set_queue="queue_files"
                        :old_file="local_file"
                        :old_delete="true"
                    />
                    <div class="custom-form-error-message">{{ validation.firstError('form.image') }}</div>
                </div>
                <div class="col-12 mb-3" :class="validation.firstError('form.product') ? 'custom-form-error' : ''">
                    <label class="form-label">Nama Produk</label>
                    <input type="text" class="form-control custom-form-control" placeholder="Nama Produk" v-model="form.product">
                    <div class="custom-form-error-message">{{ validation.firstError('form.product') }}</div>
                </div>
                <div class="col-12 mb-3">
                    <label class="form-label">Satuan</label>
                    <input type="text" class="form-control custom-form-control" placeholder="Satuan" v-model="form.unit">
                </div>
                <div class="col-12 mb-3" :class="validation.firstError('form.price') ? 'custom-form-error' : ''">
                    <label class="form-label">Harga</label>
                    <currency-input v-model.lazy="form.price" :options="{valueRange: {min: 1000}}" placeholder="Harga"/>
                    <div class="custom-form-error-message">{{ validation.firstError('form.price') }}</div>
                </div>
            </div>
        </template>
        <template v-slot:modal_footer>
            <button type="button" class="btn custom-btn-outline-02" @click="close_modal(false)">Tutup</button>
            <button type="button" class="btn custom-btn-02" @click="submit()">{{ is_edit ? 'Simpan' : 'Tambah' }}</button>
        </template>
    </modal-component>
</template>

<script>
    import ModalComponent from '@/components/external/ModalComponent'
    import CurrencyInput from '@/components/external/input/CurrencyInput'
    import FileInput from '@/components/external/input/FileInput'
    import { mapGetters } from 'vuex'
    import { Validator } from 'simple-vue3-validator'
    import Swal from 'sweetalert2'

	export default {
        emits: ['close'],
        components: {
            'modal-component': ModalComponent,
            'currency-input': CurrencyInput,
            'file-input': FileInput,
        },
        data() {
            return {
                modal: false,
                is_edit: null,
                local_file: [],
            }
        },
        validators: {
            'form.product': function(value){
                return Validator.value(value).required('Wajib di isi.')
            },
            'form.price': function(value){
                return Validator.value(value).required('Wajib di isi.')
            },
            'form.image': function(value){
                if(this.form_modal){
                    return Validator.custom(function () {
                        if (!Validator.isEmpty(value)) {
                            for(var i = 0; i < value.length; i++) {
                                if (value[i].error != '') {
                                    return 'Invalid file format'
                                }
                            }
                        }
                    })
                }
            },
        },
        computed: {
            ...mapGetters({
                form: 'service/getServicePriceForm',
            }),
        },
        methods: {
            open_modal(service_id, value){
                if(value){
                    this.is_edit = value.id
                    this.form.product = value.product
                    this.form.unit = value.unit
                    this.form.price = value.price

                    if(value.image != 'default.png'){
                        this.local_file.push({
                            error: '',
                            file_status: this.$root.copy(value.image),
                            file_name: this.$root.copy(value.image),
                            file_url: this.$root.copy(value.image_url),
                        })
                    }
                }
                this.form.service_id = service_id
                this.modal = true
            },
            close_modal(value){
                this.modal = false
                this.is_edit = null
                this.local_file = []
                this.validation.reset()
                this.$store.dispatch('service/resetServicePriceForm')
                this.$emit('close', value)
            },
            queue_files(data){
                if(data.files.length > 0){
                    let files = []
                    for (let i = 0; i < data.files.length; ++i) {
                        if(data.files[i].file){
                            files.push({
                                error: data.files[i].error,
                                file: new File([data.files[i].file], data.files[i].file.name, {type: data.files[i].file.type})
                            })
                        }
                        else{
                            files.push({
                                error: data.files[i].error,
                                file_status: data.files[i].file_status,
                                file_name: data.files[i].file_name,
                                file_url: data.files[i].file_url
                            })
                        }
                    }
                    this.form[data.ref] = files
                }
                else{
                    this.form[data.ref] = null
                }
            },
            submit(){
                let parent = this
                parent.$validate().then(function (success){
                    if(success){
                        let formData = new FormData();
                        formData.append('product', parent.form.product)
                        formData.append('unit', parent.form.unit)
                        formData.append('price', parent.form.price)
                        formData.append('service_id', parent.form.service_id)

                        if(parent.form.image){
                            for(let i= 0; i < parent.form.image.length; i++) {
                                if(parent.form.image[i].file){
                                    formData.append("image", parent.form.image[i].file, parent.form.image[i].file.name)
                                }
                                else{
                                    formData.append('image', parent.form.image[i].file_status)
                                }
                            }
                        }


                        if(parent.is_edit){
                            let data = {
                                id: parent.is_edit,
                                data: formData
                            }
                            parent.$store.dispatch('service/updateServicePrice', data).then((response) => {
                                if(response.status){
                                    parent.close_modal(true)
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Berhasil mengubah data',
                                        confirmButtonColor: parent.$root.swal('confirmButtonColor'),
                                        confirmButtonText: parent.$root.swal('doneButtonText'),
                                    })
                                }
                            })
                        }
                        else{
                            parent.$store.dispatch('service/createServicePrice', formData).then((response) => {
                                if(response.status){
                                    parent.close_modal(true)
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Berhasil menambah data',
                                        confirmButtonColor: parent.$root.swal('confirmButtonColor'),
                                        confirmButtonText: parent.$root.swal('doneButtonText'),
                                    })
                                }
                            })
                        }
                    }
                    else{
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: parent.$root.swal('errorValidationText'),
                            confirmButtonColor: parent.$root.swal('errorButtonColor'),
                            confirmButtonText: parent.$root.swal('errorButtonText'),
                        })
                    }
                })
            },
		}
	}
</script>